<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
        {{ 'ClientsList' | translate}}
    </h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
    <div class="row w-100 d-flex justify-content-between">
        <div class="col-md-5 divCreate">
            <a (click)="CreateClient()" class="btnCreate btn-icon-group">
                <i-tabler name="plus" class="icon-15 btn-icon"></i-tabler>
                {{ 'CreateClient' | translate}}
            </a>
        </div>
        <div class="col-md-6 divSearch">
            <mat-form-field appearance="outline">
                <input matInput maxlength="100" placeholder="{{ 'search' | translate }}" #searchVal
                    (change)='checkSearchVal(searchVal.value)' (keyup)="checkSearchVal(searchVal.value)"
                    (keyup.enter)="checkSearchVal(searchVal.value)" />
                <mat-icon matPrefix class="op-5 inputTxt">
                    <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
                </mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="row w-100">
        <div *ngIf="AllClients?.length==0;then NoClients else Clients"></div>

        <ng-template #NoClients>
            <div class="col-md-12">
                <p> {{ 'NoDataFound' | translate }}</p>
            </div>
        </ng-template>

        <ng-template #Clients>
            <div class="col-md-12 navi">
                <ul>
                    <li class="m-b-6" *ngFor="let client of AllClients">
                        <a (click)="SelectClient(client)">
                            <span class="name">{{ client.name }}</span>
                            <span class="phone"> {{ client.clientPhone }}</span>
                        </a>
                    </li>
                </ul>
            </div>
            <mat-divider></mat-divider>
        </ng-template>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="col-md-12 text-center">
        <button mat-button class="btnClose" (click)="onClose()"> {{ 'Cancel' | translate}}</button>
    </div>
</mat-dialog-actions>
